import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider } from "antd";
import { CheckCircleOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";

export const AceitesDocumentosPerfisVisualizacao = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  useEffect(() => {
    listarColaboradores();
  }, []);

  // LISTAR COLABORADORES
  const listarColaboradores = async () => {
    setLoading(true);
    const api = await http("get", `v1/usuario/lista_colaboradores`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Matrícula",
      dataIndex: "matricula",
      sorter: (a, b) => a.matricula?.toString()?.localeCompare(b.matricula?.toString()),
    },
    {
      title: "Colaborador",
      dataIndex: "nome",
      sorter: (a, b) => a.nome?.localeCompare(b.nome),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 100,
      render: (_, e) => (
        <Button
          loading={loading}
          onClick={() => navigate(`/aceites-documentos/perfis/tipos/${e.id}`)}
          icon={<CheckCircleOutlined />}>
          Tipos Documentos
        </Button>
      ),
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Aceites Documentos" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title={["Aceites Documentos", "Perfis"]}
              subtitle="Liberar acessos colaboradores"
              icon={<UsergroupAddOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom columns={columns} dataSource={dados} loading={loading} />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
